import { EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { isNullOrUndefined } from 'util';
import { Observable } from 'rxjs/Observable';
import { TimerObservable } from 'rxjs/observable/TimerObservable';
import * as i0 from "@angular/core";
var UtilsService = /** @class */ (function () {
    function UtilsService() {
        this.linked = {};
        this.utilsService = new EventEmitter();
    }
    UtilsService.getDate = function (fullYear, month, day) {
        try {
            if (isNullOrUndefined(fullYear) || isNullOrUndefined(month) || isNullOrUndefined(day)
                || (month < 1 || month > 12) || (day < 1 || day > 31)) {
                return null;
            }
            return new Date(fullYear, month - 1, day);
        }
        catch (error) {
            console.log('UtilsService.getDate()');
            console.error(error);
            return null;
        }
    };
    /***
     * Given a year and a month, it returns the number of days of it.
     * @param {number} month Month number (froom 1 to 12: 1 for January, 2 for February, etc.)
     * @param {number} year Year number
     * @returns {number} A number which represents the number of days of the given month/year combination
     */
    UtilsService.getNumberOfDaysForMonth = function (month, year) {
        try {
            return new Date(year, month, 0).getDate();
        }
        catch (error) {
            console.log('UtilService.getNumberOfDaysForMonth()');
            console.error(error);
            return 0;
        }
    };
    UtilsService.getOrdinalNumber = function (n) {
        try {
            var s = ['th', 'st', 'nd', 'rd'];
            var v = n % 100;
            return n + (s[(v - 20) % 10] || s[v] || s[0]);
        }
        catch (error) {
            console.log('UtilService.getOrdinalNumber()');
            console.error(error);
            return null;
        }
    };
    /***
     * Given a string with the format yyyy-M (Ex, 2016-5 ), it generates a Date object for the given parameter
     * @param {string} stringDate a string with the format yyyy-M (Ex, 2016-5 )
     * @returns {Date} A date object for the year and month sent
     */
    UtilsService.generateDateByStringYearAndMonthDate = function (stringDate) {
        var dateArray = stringDate.split('-');
        if (dateArray.length >= 2) {
            var year = Number(dateArray[0]);
            var month = Number(dateArray[1]);
            if ((Number.isSafeInteger(year) && Number.isSafeInteger(month)) && (month >= 1 && month <= 12)) {
                return UtilsService.generateDateByYearAndMonth(year, month);
            }
        }
        return null;
    };
    /***
     * Given a string with the format yyyy-M (Ex, 2016-5 ), it generates a Date object for the given parameter
     * @param {string} stringDate a string with the format yyyy-M (Ex, 2016.5 )
     * @returns {Date} A date object for the year and month sent
     */
    UtilsService.generateDateByStringYearAndMonthDateforPoint = function (stringDate) {
        var dateArray = stringDate.split('.');
        if (dateArray.length >= 2) {
            var year = Number(dateArray[0]);
            var month = Number(dateArray[1]);
            if ((Number.isSafeInteger(year) && Number.isSafeInteger(month)) && (month >= 1 && month <= 12)) {
                return UtilsService.generateDateByYearAndMonth(year, month);
            }
        }
        return null;
    };
    /***
     * Given a year and a month, it generates a Date object from those values
     * @param {number} year the year that will be set in the date object
     * @param {number} month the month (1 to 12) to be set in the date object
     * @returns {Date} A date object for the given month and year
     */
    UtilsService.generateDateByYearAndMonth = function (year, month) {
        return new Date(year, month - 1);
    };
    UtilsService.generateDateByMiliseconds = function (milisecondsDate) {
        try {
            return new Date(milisecondsDate);
        }
        catch (error) {
            console.log('');
            console.error(error);
            return null;
        }
    };
    UtilsService.millisecondsToHours = function (milliseconds) {
        try {
            return milliseconds / 1000 / 60 / 60;
        }
        catch (error) {
            console.log('UtilService.millisecondsToHours()');
            console.error(error);
            throw Number;
        }
    };
    UtilsService.millisecondsToDays = function (milliseconds) {
        try {
            return milliseconds / 1000 / 60 / 60 / 24;
        }
        catch (error) {
            console.log('UtilService.millisecondsToHDays()');
            console.error(error);
            throw Number;
        }
    };
    UtilsService.generateFormattedDateMMYYYY = function (date) {
        return UtilsService.generateFormattedDate(date, 'MMMM, YYYY');
    };
    UtilsService.generateFormattedDate = function (date, format) {
        return moment(date).format(format);
    };
    UtilsService.getArrayOfNumbers = function (numberOfElements, startfromZero) {
        if (numberOfElements === 0) {
            return [];
        }
        var resultArray = [];
        var startAt = startfromZero ? 0 : 1;
        var endAt = startfromZero ? (numberOfElements - 1) : (numberOfElements);
        for (var i = startAt; i <= endAt; i++) {
            resultArray.push(i);
        }
        return resultArray;
    };
    UtilsService.getArrayOfNumbersByRange = function (from, to) {
        var resultArray = [];
        for (var i = from; i <= to; i++) {
            resultArray.push(i);
        }
        return resultArray;
    };
    /***
     * Given a string in the 2018-01-17 10:55:05 format, it converts it into a ISO format (2018-01-17T10:55:05Z)
     * si it can be used to create a new Date object in JS
     * @param (string) notISOStringDate
     */
    UtilsService.createIsoDateTimeString = function (notISOStringDate) {
        try {
            var arrayDate = notISOStringDate.split(' ');
            console.log(arrayDate);
            if (arrayDate.length !== 2) {
                return null;
            }
            console.log(arrayDate[0] + 'T' + arrayDate[1] + 'Z');
            return arrayDate[0] + 'T' + arrayDate[1] + 'Z';
        }
        catch (error) {
            console.log('UtilService.createIsoDateTimeString()');
            console.error(error);
            return null;
        }
    };
    UtilsService.createDateFromNotISOStringDate = function (notISOStringDate) {
        try {
            var ISOStringDate = UtilsService.createIsoDateTimeString(notISOStringDate);
            if (isNullOrUndefined(ISOStringDate)) {
                return null;
            }
            return new Date(ISOStringDate);
        }
        catch (error) {
            console.log('UtilService.createDateFromNotISOStringDate()');
            console.error(error);
            return null;
        }
    };
    UtilsService.padRight = function (stringToPad, width, character) {
        if (character === void 0) { character = '0'; }
        try {
            return stringToPad.length >= width ?
                stringToPad : new Array(width - stringToPad.length + 1).join(character) + stringToPad;
        }
        catch (error) {
            console.log('UtilService.pad()');
            console.error(error);
            return null;
        }
    };
    UtilsService.generateMonthDays = function (month, year) {
        try {
            var numberOfDaysForMonth = UtilsService.getNumberOfDaysForMonth(month, year);
            var resultMontDays = [];
            for (var i = 1; i <= numberOfDaysForMonth; i++) {
                var itemMonthDay = { value: i, name: UtilsService.padRight(i.toString(), 2) };
                resultMontDays.push(itemMonthDay);
            }
            return resultMontDays;
        }
        catch (error) {
            console.log('UtilService.generateMonthDays()');
            console.error(error);
        }
    };
    UtilsService.millisecondsCounter = function (initialDelay, millisecondsPeriod, until, ascendant) {
        try {
            var counterResult = TimerObservable.create(initialDelay, millisecondsPeriod)
                .map(function (counter) {
                if (ascendant === true) {
                    return counter;
                }
                else {
                    return until - counter - 1;
                }
            }).catch(function (error) {
                console.log('UtilService.counter()');
                console.log(error);
                return Observable.throw(error);
            });
            if (until === 0) {
                return counterResult;
            }
            else {
                return counterResult.take(Math.abs(until));
            }
        }
        catch (error) {
            console.log('UtilService.counter()');
            console.log(error);
            Observable.throw(error);
        }
    };
    UtilsService.ngInjectableDef = i0.defineInjectable({ factory: function UtilsService_Factory() { return new UtilsService(); }, token: UtilsService, providedIn: "root" });
    return UtilsService;
}());
export { UtilsService };
